"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.UrlType = exports.RequestType = exports.HttpMethod = exports.DataApiQuery = void 0;
var UrlType = exports.UrlType = function (a) {
    return a.DataApi = "dataApi", a.Events = "events", a.ClientConfiguration = "clientConfiguration", a;
  }({}),
  HttpMethod = exports.HttpMethod = function (a) {
    return a.Get = "GET", a.Post = "POST", a;
  }({}),
  DataApiQuery = exports.DataApiQuery = function (a) {
    return a[a.VisitEvent = 0] = "VisitEvent", a[a.VisitData = 1] = "VisitData", a[a.DataMap = 2] = "DataMap", a;
  }({});
var EVENT_TYPE_KEYS = ["customData", "staticData", "page", "conversion", "geolocation", "activity", "experiment"],
  PARAMETER_KEYS = ["valuesCountMap", "mappingValue", "id", "nonce", "country", "environment", "city", "region", "latitude", "geolocation", "longitude", "mappingIdentifier", "postalCode", "sdkName", "sdkVersion", "kcs", "browserIndex", "browserVersion", "siteCode", "visitorCode", "currentVisit", "maxNumberPreviousVisits", "customData", "negative", "revenue", "title", "os", "conversion", "staticData", "osIndex", "browser", "referrersIndices", "overwrite", "index", "href", "experiment", "page", "variationId", "deviceType", "goalId", "ts", "key", "userAgent", "bodyUa"],
  TRACKING_KEYS = ["visit", "map"],
  QUERY_KEYS = ["sse", "visitor", "map", "events"];
var RequestType = exports.RequestType = function (a) {
  return a.Configuration = "configuration", a.Tracking = "tracking", a.RemoteData = "remoteData", a;
}({});